import { render, staticRenderFns } from "./FeedBackVoluntariosNecessidades.vue?vue&type=template&id=066f8f06&scoped=true"
import script from "./FeedBackVoluntariosNecessidades.vue?vue&type=script&lang=js"
export * from "./FeedBackVoluntariosNecessidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f8f06",
  null
  
)

export default component.exports